import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Link from 'react-router/lib/Link';
import withViewportScrollTracking from '../hocs/withViewportScrollTracking';
import OpenerImage from '../common/opener_image';
import PrimeCardElements from './prime_card_elements';
import DateLabel from '../common/date_label';
import { windowAttrs } from '../../utils/dom';
import { sendAnalyticsEvent, sendDataLayerEvent } from '../../utils/analytics';
import {
  TIME_ZONE_UTC,
  ARCHIVES_PAGE_TYPE,
  TIMESTAMP_MULTIPLIER_MS
} from '../../../js/constants';
import classNames from 'classnames';

export class PrimeCard extends Component {
  handleClick = () => {
    if (this.props.moduleType === 'related-content') {
      sendAnalyticsEvent(
        'Related Content',
        'Click',
        `${this.relatedContentAnalyticsLabel()} ${this.props.indexWithinModule}`
      );
      return;
    }
    
    if (this.props.moduleType === 'feed') {
      sendDataLayerEvent('Click', {
        module_name: this.props.moduleTitle || '',
        cta_text: this.props.truncated_title_80,
        destination_url: this.props.url,
        position: this.props.indexWithinModule - 1,
        pageModule: 'Feed',
        itemName: this.props.truncated_title_80,
        linkHeadline: this.props.truncated_title_80,
        linkTitle: this.props.truncated_title_80,
        linkType: 'article',
        linkUID: this.props.id,
      });
      sendAnalyticsEvent(
        'Feed',
        'Click',
        `Card ${this.props.indexWithinModule}`
      );
      return;
    }

    if (this.props.moduleType === 'hp_refresh_feed'
      || this.props.moduleType === 'hp_refresh_feed_ads'
    ) {
      sendDataLayerEvent('Click', {
        module_name: this.props.moduleTitle || 'Now on R29',
        cta_text: this.props.truncated_title_80,
        destination_url: this.props.url,
        position: this.props.indexWithinModule - 1,
        pageModule: 'Feed',
        itemName: this.props.truncated_title_80,
        linkHeadline: this.props.truncated_title_80,
        linkTitle: this.props.truncated_title_80,
        linkType: 'article',
        linkUID: this.props.id,
      });
    }

    sendDataLayerEvent('Click', {
      module_name: this.props.moduleTitle || '',
      cta_text: this.props.truncated_title_80,
      destination_url: this.props.url,
      position: this.props.indexWithinModule - 1,
      pageModule: this.props.moduleType,
      itemName: this.props.truncated_title_80,
      linkHeadline: this.props.truncated_title_80,
      linkTitle: this.props.truncated_title_80,
      linkType: 'article',
      linkUID: this.props.id,
    });

    sendAnalyticsEvent(
      `"${this.props.moduleTitle}" Module`,
      'Click',
      `Card ${this.props.indexWithinModule}`
    );
  };

  relatedContentAnalyticsLabel = () => {
    switch (this.props.indexWithinModule) {
      case 7: return 'Sponsored Story';
      default: return 'Story';
    }
  };

  shouldRenderESTDate = () =>
    this.props.page_type === ARCHIVES_PAGE_TYPE;

  shouldRenderDateLabel = () =>
    this.props.page_type === ARCHIVES_PAGE_TYPE
    && !this.props.archivesState.day;

  render() {
    const { archivesState, cardID, contributors, excerpt_truncated_155,
      isVideoCard, label, meta, moduleID, opener_images, rowType,
      truncated_title_80, type, url } = this.props;

    const shouldRenderESTDate = this.shouldRenderESTDate();
    const shouldRenderDateLabel = this.shouldRenderDateLabel();

    const className = classNames(
      'card', this.props.className,
      { 'with-date-label': shouldRenderDateLabel }
    );

    let published = this.props.published * TIMESTAMP_MULTIPLIER_MS;
    let timeZone;
    let dateLabel;

    if (shouldRenderESTDate) {
      const date = new Date(published);
      published = date.setUTCHours(date.getUTCHours() - 5);
      timeZone = TIME_ZONE_UTC;
    }

    if (shouldRenderDateLabel) {
      dateLabel = (
        <DateLabel moduleID={moduleID}
          timestamp={published}
          archivesState={archivesState}
        />
      );
    }

    const openerImageProps = {
      isVideoCard, opener_images, rowType, type
    };
    const cardProps = {
      cardID, contributors, excerpt_truncated_155,
      isVideoCard, label, meta, truncated_title_80,
      type, published, timeZone
    };

    return (
      <div onClick={this.handleClick} className={className}>
        {dateLabel}
        <Link to={url}>
          <OpenerImage {...openerImageProps} />
          <PrimeCardElements {...cardProps} />
        </Link>
      </div>
    );
  }
}

const decorator = withViewportScrollTracking({
  eventParams() {
    return [
      'Scroll Depth',
      'Scroll',
      'Reached 5th card'
    ];
  },
  shouldTrackScrollEvent() {
    const onMobile = windowAttrs().innerWidth <= 760;
    return this.props.cardID === 5 && onMobile;
  }
});

export default decorator(PrimeCard);

PrimeCard.propTypes = {
  archivesState: PropTypes.object,
  cardID: PropTypes.number.isRequired,
  meta: PropTypes.object.isRequired,
  moduleID: PropTypes.number.isRequired,
  moduleTitle: PropTypes.string.isRequired,
  moduleType: PropTypes.string.isRequired,
  rowType: PropTypes.string.isRequired,
  indexWithinModule: PropTypes.number.isRequired,
  className: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  truncated_title_80: PropTypes.string.isRequired,
  isVideoCard: PropTypes.bool.isRequired,
  page_type: PropTypes.string.isRequired,
  published: PropTypes.number.isRequired,
  excerpt_truncated_155: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  contributors: PropTypes.arrayOf(
    PropTypes.object.isRequired
  ).isRequired,
  opener_images: PropTypes.arrayOf(
    PropTypes.object.isRequired
  ).isRequired,
  url: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired
};

PrimeCard.defaultProps = {
  className: '',
  type: '',
  meta: {},
  moduleType: '',
  truncated_title_80: '',
  published: 0,
  excerpt_truncated_155: '',
  label: '',
  contributors: [],
  opener_images: [],
  url: '',
  id: 0
};
